import { createAction, props } from '@ngrx/store';
import { DataResult } from '@progress/kendo-data-query';
import { IntegrationArtifact } from '../../models/integration-artifact';
import { FetchArgs } from 'src/app/shared/models/core';

export enum IntegrationDashboardActionsEnum {
    GetAllIntegrationEventLogs = '[INTEGRATIONS DASHBOARD] Get all Integration EventLogs',
    SetAllIntegrationEventLogs = '[INTEGRATIONS DASHBOARD] Set all Integration EventLogs',
    DownloadIntegrationArtifact = '[INTEGRATIONS DASHBOARD] Download Integration Artifact',
    IntegrationArtifactDownloaded = '[INTEGRATIONS DASHBOARD] Integration ArtifactDownloaded',
    IntegrationArtifactDownloadCompleted = '[INTEGRATIONS DASHBOARD] Integration ArtifactDownload completed',
    SetStatus = '[INTEGRATIONS DASHBOARD] Set Status',
    SetArgs = '[INTEGRATIONS DASHBOARD] Set Args',
    RunDOPsPipeline = '[INTEGRATIONS DASHBOARD] Run DOPs Pipeline',
    RunDOPsPipelineSuccess = '[INTEGRATIONS DASHBOARD] Run DOPs Pipeline Success',
    RunDOPsPipelineFailure = '[INTEGRATIONS DASHBOARD] Run DOPs Pipeline Failure'
}

export const setStatus = createAction(IntegrationDashboardActionsEnum.SetStatus, props<{ status: string }>());

export const setArgs = createAction(IntegrationDashboardActionsEnum.SetArgs, props<{ args: FetchArgs }>());

export const getAllIntegrationEventLogs = createAction(IntegrationDashboardActionsEnum.GetAllIntegrationEventLogs);

export const setAllIntegrationEventLogs = createAction(
    IntegrationDashboardActionsEnum.SetAllIntegrationEventLogs,
    props<{ integrationEventLogList: DataResult }>()
);

export const downloadIntegrationArtifact = createAction(
    IntegrationDashboardActionsEnum.DownloadIntegrationArtifact,
    props<{ artifact: IntegrationArtifact }>()
);

export const integrationArtifactDownloaded = createAction(
    IntegrationDashboardActionsEnum.IntegrationArtifactDownloaded,
    props<{ file: any; artifact: IntegrationArtifact }>()
);
export const integrationArtifactDownloadCompleted = createAction(
    IntegrationDashboardActionsEnum.IntegrationArtifactDownloadCompleted
);

export const runDOPsPipeline = createAction(
    IntegrationDashboardActionsEnum.RunDOPsPipeline,
    props<{ integration: string }>()
);
export const runDOPsPipelineSuccess = createAction(IntegrationDashboardActionsEnum.RunDOPsPipelineSuccess);
export const runDOPsPipelineFailure = createAction(
    IntegrationDashboardActionsEnum.RunDOPsPipelineFailure,
    props<{ error: unknown }>()
);

export const IntegrationDashboardActions = {
    getAllIntegrationEventLogs,
    setAllIntegrationEventLogs,
    downloadIntegrationArtifact,
    integrationArtifactDownloaded,
    integrationArtifactDownloadCompleted,
    setArgs,
    setStatus,
    runDOPsPipeline,
    runDOPsPipelineSuccess,
    runDOPsPipelineFailure
};
